import { ID } from '../id';

export enum AppTypes {
  WebApp = 'Web',
  ElectronMacApp = 'Electron Mac',
  ElectronWinApp = 'Electron Win',
  IosApp = 'ios',
  AndroidApp = 'android',
}

export type SuperProperties = {
  app_type: AppTypes;
  app_version: string;
};

export enum UserPropertiesKeys {
  WorkSituation = 'work_situation',
  HearAbout = 'how_did_you_hear_about_us',
  GriplyUserId = 'griply_user_id',
  IsInternal = 'is_internal',
  CalendarHideCompletedTasks = 'calendarHideCompletedTasks',
  CalendarHideHabits = 'calendarHideHabits',
  CalendarHideExternalCalendarEvents = 'calendarHideExternalCalendarEvents',
  HabitsGrouping = 'habits_grouping',
  HabitsSorting = 'habits_sorting',
  PmfDisappointment = 'pmf_disappointment',
}

export type UserProperties = {
  [UserPropertiesKeys.WorkSituation]: string;
  [UserPropertiesKeys.HearAbout]: string;
  [UserPropertiesKeys.GriplyUserId]: ID;
  [UserPropertiesKeys.IsInternal]: boolean;
  [UserPropertiesKeys.CalendarHideCompletedTasks]: boolean;
  [UserPropertiesKeys.CalendarHideHabits]: boolean;
  [UserPropertiesKeys.CalendarHideExternalCalendarEvents]: boolean;
  [UserPropertiesKeys.HabitsGrouping]: string;
  [UserPropertiesKeys.HabitsSorting]: string;
  [UserPropertiesKeys.PmfDisappointment]: string;
};
